export const ACTIVE_MEMBERSHIP = 2;
export const DEACTIVE_MEMBERSHIP = 4;
export const PENDING_PAYMENT = 5;

// Estados visibles de una solicitud de exportación (/memberships/export-requests).
// El backend maneja 4 valores internos ('pending'|'processing'|'ready'|'failed');
// 'processing' se mapea a PENDING acá porque el spec solo distingue 3 estados
// (ver EXPORT_STATUS_TO_UI_STATE en MyDownloads.vue). No confundir con los
// status codes de Membership de arriba — son dominios distintos.
// Qué genera una solicitud de "Mis Descargas" (exportType del backend).
export const EXPORT_TYPES = {
  MEMBERSHIPS: 'memberships',
  USERS: 'users',
  PET_HEALTH: 'petHealth'
};

export const EXPORT_REQUEST_STATUS = {
  PENDING: 'pending',
  READY: 'ready',
  FAILED: 'failed'
};

// Estados de una solicitud de oposición ARCO+ (Ley 21.719) — vienen tal cual del enum
// del backend (opposition-requests.status), sin remapeo.
export const OPPOSITION_REQUEST_STATUS = {
  RECEIVED: 'received',
  PENDING_MANUAL_REVIEW: 'pending_manual_review',
  ACCEPTED: 'accepted',
  REJECTED: 'rejected'
};

// Estado del pedido de bloqueo asociado a una solicitud de oposición (independiente
// del status principal de arriba) — también tal cual del enum del backend.
export const BLOCK_STATUS = {
  NOT_REQUESTED: 'not_requested',
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  REJECTED: 'rejected'
};

// Valores válidos de Service.iconId — deben coincidir exactamente con los
// nombres de carpeta en pawer_ui_app/assets/icons/icon-services/, ya que la
// app resuelve el ícono interpolando este string directo en la ruta del
// asset (sin alias). Un valor fuera de esta lista no muestra ningún ícono.
// Niveles de riesgo del análisis automático de fraude Don Graff (RiskScore.riskLevel).
// El nivel viene ya calculado por el backend (puede haber overrides forzados que lo
// desacoplen del score numérico) — la UI solo traduce label/color, nunca lo recalcula.
export const DON_GRAF_RISK_LEVELS = {
  LOW: { label: 'RIESGO BAJO', color: 'success' },
  MEDIUM: { label: 'RIESGO MEDIO', color: 'warning' },
  HIGH: { label: 'RIESGO ALTO', color: 'orange darken-1' },
  CRITICAL: { label: 'RIESGO CRÍTICO', color: 'error' }
};

// Traducción de RiskScore.signals[].code a lenguaje legible. Un code no listado acá
// debe mostrarse con DON_GRAF_RISK_SIGNAL_FALLBACK_LABEL, nunca omitirse ni mostrarse crudo.
export const DON_GRAF_RISK_SIGNALS = {
  DOCUMENT_REUSED_SAME_USER: 'Documento ya usado (mismo usuario)',
  DOCUMENT_REUSED_OTHER_USER: 'Documento reusado (otro usuario)',
  DOCUMENT_REUSED_MULTIPLE_USERS: 'Documento usado por múltiples usuarios',
  CREATION_MODIFICATION_DATE_MISMATCH: 'Fecha de creación distinta a modificación',
  MULTIPLE_DOCUMENT_FINGERPRINTS: 'Múltiples identificadores internos (PDF editado)',
  NO_DIGITAL_SIGNATURE: 'Sin firma digital',
  CREATOR_PRODUCER_MISMATCH: 'Software creador distinto al productor',
  C2PA_EDIT: 'Manifest C2PA indica edición',
  C2PA_AI_MODIFICATION: 'Manifest C2PA indica modificación por IA'
};

export const DON_GRAF_RISK_SIGNAL_FALLBACK_LABEL = 'Otra señal de riesgo';

// Valores especiales de Metadata.results[].observation (texto libre del análisis de
// integridad EXIF/C2PA) que la UI debe reconocer en vez de mostrar como hallazgo crudo.
export const DON_GRAF_INTEGRITY_CLEAN_OBSERVATION =
  'Headers del documento no sugieren modificación';
export const DON_GRAF_INTEGRITY_UNEVALUATED_PREFIX = 'No se pudo evaluar el documento:';

export const SERVICE_ICON_IDS = [
  'accident',
  'chip',
  'collar',
  'cremation',
  'deworming',
  'discount',
  'disease',
  'exams',
  'flights',
  'general',
  'grooming',
  'hotel-petsitting',
  'legal-guidance',
  'medical-record',
  'medicine',
  'megaphone',
  'nail-cutting',
  'sterilization',
  'televet',
  'transport',
  'urgency',
  'vaccinate',
  'veterinary-consultation',
  'walks'
];
